var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.reminders),function(reminder,index){return _c('div',{key:index,staticClass:"ds-reminders"},[_c('div',{staticClass:"ds-reminders__item"},[_c('i',{staticClass:"icon-stopwatch ds_reminders__bell"}),_c('span',{staticClass:"ds-reminders__title"},[_vm._v(_vm._s(_vm.$t(`reminders.${reminder.value}`)))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }